import React from 'react';
import AverageScoreBars from '@/components/globalPrompts/insights/charts/AverageScoreBars';
import { NumericQuestionInsight } from '../insightsTypes';
import QuestionCardBarSection from './QuestionCardBarSection';

// Global numeric questions use a fixed 1–10 scale (see server generation default).
const SCALE_MAX = 10;

const NumericQuestionCard: React.FC<{ insight: NumericQuestionInsight }> = ({ insight }) => (
    <QuestionCardBarSection title="Per-project average">
        <AverageScoreBars
            rows={insight.perProject.map((project) => ({
                label: project.projectName,
                average: project.average,
                responses: project.responses,
            }))}
            max={SCALE_MAX}
        />
    </QuestionCardBarSection>
);

export default NumericQuestionCard;
